import React from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import {
  CandidateFiltersGroupLayout,
  ExperienceContent,
  useExperienceState,
} from 'talent_matching/components/filters';
import WorkPreferencesFiltersGroup from './work_preferences_filters_group';
import MyGreenhouseAppliedFilters from './my_greenhouse_applied_filters';

const t = withLocalePrefix('talent_matching.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
};

// Offers only the filters AdeptID can honor, so no control here narrows nothing.
const MyGreenhouseFilterRow = ({ onClearAll }: Props) => {
  const experienceState = useExperienceState();

  const appliedCount =
    experienceState.minValue || experienceState.maxValue ? 1 : 0;

  return (
    <Stack spacing={0} sx={{ marginBottom: 2 }}>
      <Stack direction="row" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <CandidateFiltersGroupLayout
            appliedCount={appliedCount}
            onClear={experienceState.clear}
            width="330px"
          >
            <ExperienceContent
              state={experienceState}
              showCompanyExperience={false}
            />
          </CandidateFiltersGroupLayout>
          <WorkPreferencesFiltersGroup />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
      </Stack>
      <MyGreenhouseAppliedFilters />
    </Stack>
  );
};

export default MyGreenhouseFilterRow;
